export default "__VITE_ASSET__DIW6ZcYB__"